import { z } from "zod";

import { REQUIRED_MESSAGE } from "@/utils";

export const plataformFormSchema = z.object({
  project_id: z.string().uuid().optional(), // ID do projeto (opcional, pois plataformas podem estar dentro de projetos)
  markup_value: z.number().optional(),
  commission_value: z.number().optional(),
  conversion_rate: z.number().optional(),
  tax_rate: z.number().optional(),
  cancellation_fee: z.number().optional(),
  operating_expenses: z.number().optional(),
  customer_base: z.number().optional(),
  planos: z.array(z.string()),
  landing_page: z.object({
    title: z.string().min(1, { message: REQUIRED_MESSAGE }),
    description: z.string().min(1, { message: REQUIRED_MESSAGE }),
    primary_button_text: z.string().min(1, { message: REQUIRED_MESSAGE }),
    image_banner_primary: z
      .instanceof(File, {
        message: "Você deve selecionar uma imagem para o banner primário",
      })
      .optional(),
    primary_logo: z
      .instanceof(File, {
        message: "Você deve selecionar uma imagem para o logo primário",
      })
      .optional(),
    secondary_logo: z
      .instanceof(File, {
        message: "Você deve selecionar uma imagem para o logo secundário",
      })
      .optional(),
    whatsapp_number: z.string().optional(),
    instagram_url: z.string().optional(),
    facebook_url: z.string().optional(),
    contact_email: z.string().optional(),
    primary_color: z.string().optional(),
  }),
});

export const clientIdSchema = z.object({
  clientId: z.string().uuid({ message: REQUIRED_MESSAGE }),
});

export type TPlataformFormData = z.infer<typeof plataformFormSchema>;
